import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import useTailwindBrand from '../../Theme/useTailwindBrand';

// Supprimer l'avertissement de dépréciation Google Maps AutocompleteService
if (typeof window !== 'undefined') {
  const originalWarn = console.warn;
  console.warn = (...args: unknown[]) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('AutocompleteService is not available to new customers')) {
      return;
    }
    originalWarn.apply(console, args);
  };
}

export interface InputAddressFieldProps {
  label?: string;
  placeholder?: string;
  default?: string;
  required?: boolean;
  error?: string;
  getPlaceId: (placeId: string) => void;
  readonly?: boolean
  isEditing?: boolean
}

const InputAddressField: React.FC<InputAddressFieldProps> = ({
  label,
  placeholder = 'Ex : 22 rue auber, Paris',
  default: defaultValue,
  required = false,
  error,
  getPlaceId,
  readonly,
  isEditing
}) => {
  // const [editMode, setEditMode] = useState(readonly ?? false);
  const { classes, brandConfig } = useTailwindBrand();

  // useEffect(() => {
  //   if (defaultValue) {
  //     setEditMode(true);
  //   }
  // }, [defaultValue]);

  const contentWrapperClass = 'pt-6 pb-2 px-3';

  const renderContent = () => {
    if (readonly) {
      return (
        <div className={`flex justify-between ${contentWrapperClass} min-h-[46px] bg-white rounded-md border ${error ? `${classes.errorBorder} border-l-` : 'border-gray-400'}`}>
          <div>
            <p className={classes.fontFamily}>{defaultValue}</p>
          </div>
          {/* <button
            type="button"
            onClick={() => setEditMode(false)}
            className="cursor-pointer p-0 border-0 bg-transparent"
            aria-label="Modifier l’adresse"
          >
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.72152 0C14.6972 0 18.7344 4.03714 18.7344 8.98714C18.7344 13.9629 14.6972 18 9.72152 18C4.77152 18 0.734375 13.9629 0.734375 8.98714C0.734375 4.03714 4.77152 0 9.72152 0ZM9.72152 7.49571L11.8815 5.36143C12.8587 4.37143 14.3501 5.86286 13.3858 6.86572L11.2258 8.98714L13.3858 11.1471C14.3629 12.1243 12.8587 13.6157 11.8815 12.6514L9.72152 10.4914L7.58723 12.6514C6.59723 13.6286 5.11866 12.1243 6.08295 11.1471L8.21723 8.98714L6.08295 6.85286C5.09295 5.86286 6.58438 4.35857 7.58723 5.34857L9.72152 7.49571Z"
                fill="#808080"
              />
            </svg>
          </button> */}
        </div>
      );
    }

    return (
      <div className={`bg-white rounded-md border ${error ? `${classes.errorBorder} border-l-` : isEditing ? classes.primaryBorder : 'border-gray-400'}  pt-6 min-h-[46px]`}>
        <GooglePlacesAutocomplete
          // rea
          apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
          apiOptions={{ language: 'fr', region: 'fr' }}
          autocompletionRequest={{ types: ['address'] }}
          selectProps={{
            isClearable: true,
            placeholder,
            className: `${classes.fontFamily} border-none focus:outline-none block bg-transparent w-full font-normal h-max z-50`,
            onChange: (search: { value: { place_id: string } } | null) => {
              if (search?.value?.place_id) getPlaceId(search?.value?.place_id);
            },
            styles: {
              input: (provided: object) => ({
                ...provided,
                padding: '0',
                fontFamily: brandConfig.fontFamily,
              }),
              dropdownIndicator: (provided: object) => ({
                ...provided,
                border: 'none',
                color: 'transparent',
                display: 'none',
              }),
              placeholder: (provided: object) => ({
                ...provided,
                border: 'none',
                fontFamily: brandConfig.fontFamily,
              }),
              indicatorSeparator: (provided: object) => ({
                ...provided,
                border: 'none',
                display: 'none',
                color: 'white',
              }),
              noOptionsMessage: (provided: object) => ({
                ...provided,
                border: 'none',
                color: 'white',
              }),
              loadingMessage: (provided: object) => ({
                ...provided,
                border: 'none',
                color: 'white',
              }),
              menu: (provided: object) => ({
                ...provided,
                fontFamily: brandConfig.fontFamily,
              }),
              control: (provided: object) => ({
                ...provided,
                border: 0,
                minHeight: 0,
                height: '1%',
                boxShadow: 'none',
                backgroundColor: 'transparent',
                fontFamily: brandConfig.fontFamily,
              }),
            },
          }}
        />
      </div>
    );
  };

  return (
    <div className=''>
      <FormControl variant="filled" fullWidth>
        <InputLabel
          shrink
          required={required}
          className={`${classes.fontFamily} ${error ? classes.error : classes.text} font-semibold`}
        >
          {label}
        </InputLabel>
        {renderContent()}
      </FormControl>
      <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>
        {error}
      </FormHelperText>
      {!readonly && defaultValue &&
        <FormHelperText className={`${classes.fontFamily} ${classes.primaryText} italic font-semibold`}>
          <span className='underline font-bold'>Votre adresse actuelle :</span> {defaultValue}
        </FormHelperText>
      }
    </div>
  );
};

export default InputAddressField;
